import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "../lib/api";

export default function SpecialsBanner() {
  const [banner, setBanner] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/banner").then((res) => {
      setBanner(res.data);
      const key = `releaf_banner_dismissed_${res.data.updated_at || ""}`;
      setHidden(sessionStorage.getItem(key) === "1");
    }).catch(() => setBanner(null));
  }, []);

  if (!banner || !banner.enabled || !banner.text || hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem(`releaf_banner_dismissed_${banner.updated_at || ""}`, "1");
    setHidden(true);
  };
  const internal = banner.link_url && banner.link_url.startsWith("/");

  return (
    <div data-testid="specials-banner" className="relative bg-forest text-ivory">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-12 py-2.5 text-center text-sm">
        <span data-testid="specials-banner-text">{banner.text}</span>
        {banner.link_url && banner.link_label && (
          internal ? (
            <Link to={banner.link_url} data-testid="specials-banner-link" className="font-semibold underline underline-offset-4 hover:text-cream">{banner.link_label}</Link>
          ) : (
            <a href={banner.link_url} target="_blank" rel="noreferrer" data-testid="specials-banner-link" className="font-semibold underline underline-offset-4 hover:text-cream">{banner.link_label}</a>
          )
        )}
      </div>
      <button data-testid="specials-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="absolute right-3 top-1/2 -translate-y-1/2 rounded-md p-1 text-ivory/70 transition-colors hover:text-ivory">
        <X size={16} />
      </button>
    </div>
  );
}
